export default __webpack_public_path__ + "static/media/ir.037f59a6.svg";